import api from './api';

// Boş/null parametreleri düşür — sorgu dizesi temiz kalsın (leaveDashboardService deseni).
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

export const getLeaveBalanceReport = (params) =>
  api.get('/v1/leave-balance-report', { params: clean(params) });

// Nakde Çevrilecek İzinler — devir tavanı aşımı ve süresi dolan devir (aynı kapsam kuralı).
export const getLeavePayoutReport = (params) =>
  api.get('/v1/leave-balance-report/payouts', { params: clean(params) });

export const exportLeavePayoutReport = (params) =>
  api.get('/v1/leave-balance-report/payouts/export', { params: clean(params), responseType: 'blob' });
